import { Bar } from "react-chartjs-2";
import React from "react";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import styled from "styled-components";

const BarChart = ({ chartData }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );
    return (
        <Chart>
            {chartData &&
                Object.keys(chartData).length !== 0 &&
                Object.getPrototypeOf(chartData) === Object.prototype && (
                    <Bar data={chartData} />
                )}
        </Chart>
    );
};

const Chart = styled.div`
  width: 100%;
  @media (min-width: 900px) {
    width: 50%;
  }
`;

export default BarChart;
